module.exports = __webpack_public_path__ + "img/small-2.e3e12de2.png";